export default __webpack_public_path__ + "static/media/info.1a0e13eb.svg";